import dayjs from "dayjs";
import { checkUserPermissionFunc, formatTimeRangeToAMPM } from "../../../components/common/CommonFunctions";

export const MAX_BACKDATE_DAYS = 31;

export const apiErrorMessage = (res, fallback = "Something went wrong") => {
    if (!res) return fallback;
    if (typeof res === "string") return res;
    if (res.message) return res.message;
    if (res.detail) {
        return Array.isArray(res.detail) ? res.detail.join(", ") : String(res.detail);
    }
    return fallback;
};

export const MAX_SWAP_AHEAD_DAYS = 90;

export const disableShiftChangeDate = (current) =>
    !current
    || current.isAfter(dayjs().endOf("day"))
    || current.isBefore(dayjs().subtract(MAX_BACKDATE_DAYS, "day").startOf("day"));

export const disableSwapDate = (current) =>
    !current
    || current.isBefore(dayjs().startOf("day"))
    || current.isAfter(dayjs().add(MAX_SWAP_AHEAD_DAYS, "day").endOf("day"));

export const canSubmitShiftChangeRequest = () => {
    const isAdmin = JSON.parse(sessionStorage.getItem("is_admin") || "false");
    const isSuperAdmin = JSON.parse(sessionStorage.getItem("is_super_admin") || "false");
    const { add: addPermission } = checkUserPermissionFunc("attendance", "Shift Change Requests", "SubMenu");
    return Boolean(addPermission || isAdmin || isSuperAdmin);
};

export const canReviewShiftChangeRequests = () => {
    const isAdmin = JSON.parse(sessionStorage.getItem("is_admin") || "false");
    const isSuperAdmin = JSON.parse(sessionStorage.getItem("is_super_admin") || "false");
    const { permission: viewPermission } = checkUserPermissionFunc("attendance", "Shift Change Requests", "SubMenu");
    return Boolean(isAdmin || isSuperAdmin || viewPermission);
};

export const canViewMyShiftChangeRequests = () => {
    return canSubmitShiftChangeRequest() || canReviewShiftChangeRequests();
};

export const buildShiftOptionLabel = (shift) => {
    const range = formatTimeRangeToAMPM(
        shift.shift_timings_from || shift.Start_timing,
        shift.shift_timings_to || shift.end_timing,
    );
    const name = shift.shift_name || shift.name || "Shift";
    return range ? `${name} (${range})` : name;
};

export const formatShiftTimeRange = (shiftIn, shiftOut) => {
    if (!shiftIn && !shiftOut) return null;
    const fmt = (iso) => (iso ? dayjs(iso).format("h:mm A") : "—");
    return `${fmt(shiftIn)} – ${fmt(shiftOut)}`;
};

export const requestTypeLabel = (type) => (type === "swap" ? "Swap" : "Change");

export const shiftRequestStatusLabel = (row) => {
    if (!row) return "";
    if (row.request_type === "swap" && row.status === "pending") {
        if (row.counterpart_status === "pending") {
            return row.my_role === "counterpart" ? "Waiting for you" : "Waiting for swap";
        }
        if (row.counterpart_status === "accepted") return "Pending approval";
    }
    return row.status || "";
};

export const buildSwapCandidateLabel = (person) => {
    if (!person) return "";
    const name = person.employee_name || "Employee";
    const code = person.employee_id ? `${person.employee_id} · ` : "";
    const shift = person.shift_name || "Shift";
    const range = formatTimeRangeToAMPM(person.shift_timings_from, person.shift_timings_to);
    return range ? `${code}${name} (${shift} · ${range})` : `${code}${name} (${shift})`;
};

export const toEmployeeDetails = (details, fallback = {}) => {
    const source = details && typeof details === "object" ? details : {};
    const name = source.employee_name || source.first_name || fallback.employee_name || fallback.first_name || "-";
    const code = source.employee_id || fallback.employee_id || "";
    const designation = source.designation || source.designation_id;
    return {
        ...source,
        title: source.title || "",
        first_name: name,
        last_name: source.last_name || "",
        profile: source.profile || fallback.profile || "",
        id: code,
        employee_id: code,
        designation_id: designation?.designation_name
            ? designation
            : designation?.name
                ? { id: designation.id, designation_name: designation.name }
                : { id: 0, designation_name: fallback.designation_name || "" },
    };
};
